export enum ToastMessageType {
  WARNING = 'Warning',
  SUCCESS = 'Success',
  ERROR = 'Error',

  SUBSCRIPTION_WARNING = 'subscription_warning',
  SUBSCRIPTION_SUCCESS = 'subscription_success',
}
